import clsx from 'clsx';
import React from 'react';

interface IInput {
  id?: string;
  variant: 'search' | 'text';
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  disabled?: boolean;
  className?: string;
  error?: boolean;
}
export default function Input({
  id,
  variant,
  placeholder,
  onChange,
  value,
  disabled,
  className,
  error,
}: IInput) {
  return (
    <input
      id={id}
      className={clsx(
        className,
        'border rounded-6 placeholder:font-semibold text-primary placeholder:text-gray py-2.5 outline-0 bg-white overflow-ellipsis',
        variant === 'search' &&
          'flex-shrink w-full max-tablet:h-10 max-tablet:text-12 pr-4 pl-11 max-tablet:pl-10 bg-search bg-[length:20px_20px] bg-no-repeat bg-[16px_center] max-tablet:bg-[length:16px_16px]',
        variant === 'text' && 'px-3 w-full',
        error ? 'border-red' : 'border-borderColor'
      )}
      type={'text'}
      placeholder={placeholder}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange ? onChange(e) : null
      }
      value={value}
      disabled={disabled}
    />
  );
}
